import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore'; // Asegúrate de importar doc y updateDoc
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { db } from '../utils/firebaseConfig';
import GeneralNavbar from './GeneralNavbar';
import './AdminProductList.css'; // Puedes reutilizar los estilos

function OfferList() {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [nameSearchTerm, setNameSearchTerm] = useState('');
  const [descriptionSearchTerm, setDescriptionSearchTerm] = useState('');
  const [limit, setLimit] = useState(10); // Usando el límite de visualización
  const [idSearchTerm, setIdSearchTerm] = useState('');

  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/admin');
  };

  const filterOffers = useCallback(async () => {
    setLoading(true);
    try {
      const offersRef = collection(db, 'offers');
      let filteredOffersList = [];

      // Filtro por ID
      if (idSearchTerm) {
        const idQuery = query(offersRef, where('id', '==', Number(idSearchTerm)));
        const idQuerySnapshot = await getDocs(idQuery);
        filteredOffersList = idQuerySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      } else {
        // Obtener todas las ofertas y filtrar en el cliente
        const querySnapshot = await getDocs(offersRef);
        filteredOffersList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Aplicar filtro por nombre y descripción en el cliente
        if (nameSearchTerm) {
          filteredOffersList = filteredOffersList.filter((offer) =>
            offer.name.toLowerCase().includes(nameSearchTerm.toLowerCase())
          );
        }

        if (descriptionSearchTerm) {
          filteredOffersList = filteredOffersList.filter((offer) =>
            offer.description.toLowerCase().includes(descriptionSearchTerm.toLowerCase())
          );
        }
      }

      // Ordenar por ID
      const sortedOffers = filteredOffersList.sort((a, b) => a.id - b.id);
      setOffers(sortedOffers);
    } catch (error) {
      console.error('Error filtering offers: ', error);
    } finally {
      setLoading(false);
    }
  }, [idSearchTerm, nameSearchTerm, descriptionSearchTerm]);

  useEffect(() => {
    filterOffers();
  }, [filterOffers]);

  const toggleOfferStatus = async (numericId, currentStatus) => {
    try {
      const offersRef = collection(db, 'offers');
      const querySnapshot = await getDocs(query(offersRef, where('id', '==', numericId)));

      if (querySnapshot.empty) {
        console.error('No se encontró la oferta con el id numérico:', numericId);
        return;
      }

      const offerDoc = querySnapshot.docs[0];
      const offerRef = doc(db, 'offers', offerDoc.id);

      await updateDoc(offerRef, { enabled: !currentStatus });

      filterOffers();
    } catch (error) {
      console.error('Error updating offer status: ', error);
    }
  };

  const handleNameSearch = (e) => {
    setNameSearchTerm(e.target.value);
  };

  const handleDescriptionSearch = (e) => {
    setDescriptionSearchTerm(e.target.value);
  };

  const handleIdSearch = (e) => {
    setIdSearchTerm(e.target.value);
  };

  const loadMoreOffers = () => {
    setLimit((prevLimit) => prevLimit + 3);
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text('Lista de Ofertas', 14, 10);

    // Ordenar las ofertas por categoría alfabéticamente
    const sortedOffers = [...offers].sort((a, b) => a.category.localeCompare(b.category));

    autoTable(doc, {
        startY: 20,
        head: [['ID', 'Nombre', 'Descripción', 'Categoría', 'Precio']],
        body: sortedOffers.map((offer) => [
            offer.id,
            offer.name,
            offer.description,
            offer.category,
            `$${offer.price}` // Precio formateado con 2 decimales
        ]),
        theme: 'striped',
        styles: { fontSize: 10 },
        headStyles: { fillColor: [0, 128, 255] }, // Azul para el encabezado
        columnStyles: {
            0: { cellWidth: 15 }, // ID
            1: { cellWidth: 40 }, // Nombre
            2: { cellWidth: 80 }, // Descripción
            3: { cellWidth: 30 }, // Categoría
            4: { cellWidth: 20, halign: 'right' } // Precio alineado a la derecha
        }
    });

    doc.save('ofertas.pdf');
};


  return (
    <div className="admin-product-list"> {/* Reutiliza los mismos estilos */}
      <GeneralNavbar title="Lista de Ofertas" onBackClick={handleBackClick} />
      <div className="search-bar">
        <input
          type="number"
          placeholder="Buscar por ID..."
          value={idSearchTerm}
          onChange={handleIdSearch}
          className="search-input"
        />
        <input
          type="text"
          placeholder="Buscar por Nombre..."
          value={nameSearchTerm}
          onChange={handleNameSearch}
          className="search-input"
        />
        <input
          type="text"
          placeholder="Buscar por Descripción..."
          value={descriptionSearchTerm}
          onChange={handleDescriptionSearch}
          className="search-input"
        />
        <button onClick={generatePDF} className="pdf-button">
        Generar PDF
      </button>
      </div>
      {loading ? (
        <p className="centered-text">Cargando...</p>
      ) : offers.length === 0 ? (
        <p className="centered-text">No hay ofertas.</p>
      ) : (
        <>
          <ul>
            {offers.slice(0, limit).map((offer) => (
              <li key={offer.id} className={offer.enabled ? '' : 'disabled'}>
                <Link to={`/admin/offers/edit/${offer.id}`}>
                  {offer.id} - {offer.name} - {offer.description} - {offer.price}$
                </Link>
                <button onClick={() => toggleOfferStatus(offer.id, offer.enabled)}>
                  {offer.enabled ? 'Deshabilitar' : 'Habilitar'}
                </button>
              </li>
            ))}
          </ul>
          {limit < offers.length && (
            <button onClick={loadMoreOffers} className="load-more-button">
              Cargar más
            </button>
          )}
        </>
      )}
    </div>
  );
}

export default OfferList;

